import React, { useEffect, useState } from 'react';
import {
    ButtonBasic,
    InputDinamycPlaceholder,
    Checkbox,
} from '@lk-gtcom/ecomlab-components';
import { TitlePage } from '../../../TitlePage/TitlePage';
import './ModalParamsRules.scss';

interface StrategyParam {
    portal_name?: string;
    name?: string;
    type: 'boolean' | 'integer' | 'string';
    id?: string;
    attr_id?: string;
    value?: any;
}

interface StrategyParamValue {
    [key: string]: {
        type: string;
        value: boolean | number | string;
    };
}

interface ModalParamsRulesProps {
    strategyInfo: any;
    currentCard?: {
        portal_name?: string;
    };
    strategyParams?: StrategyParam[];
    strategyParamValue: StrategyParamValue;
    setStrategyParamValue: React.Dispatch<React.SetStateAction<StrategyParamValue>>;
    setStrategyParams: (strategyParams: any) => void;
    onClose: () => void;
    onChangeStrategy: (strategyInfo: any) => void;
}

const ModalParamsRules: React.FC<ModalParamsRulesProps> = ({
    strategyInfo,
    currentCard,
    strategyParams,
    strategyParamValue,
    setStrategyParamValue,
    setStrategyParams,
    onClose,
    onChangeStrategy
}) => {

    useEffect(() => {
        if (strategyParams) {
            // 1. Создаем новый пустой объект для параметров
            const newParams: StrategyParamValue = {};

            // 2. Заполняем его значениями из strategyParams
            strategyParams.forEach(({ type, id, attr_id, value }) => {
                const paramKey = id || attr_id!;
                const paramType = type || value?.type;
                const paramValue = value?.value ?? value;

                // Boolean: всегда записываем (по умолчанию false)
                if (paramType === 'boolean') {
                    newParams[paramKey] = {
                        type: 'boolean',
                        value: paramValue === true, // true только если явно указано
                    };
                }
                // String/Integer: записываем, если есть значение
                else if (paramValue !== undefined) {
                    newParams[paramKey] = {
                        type: paramType,
                        value: paramValue,
                    };
                }
            });

            // 3. Полностью перезаписываем состояние (сброс + новые значения)
            setStrategyParamValue(newParams);
        }
    }, [strategyParams]);


    return (
        <div className="modal-params-rules">
            <div className="modal-params-rules__header">
                <TitlePage
                    title='Параметры'
                />
            </div>

            <div className="modal-params-rules__content">
                <TitlePage
                    medium
                    title={currentCard?.portal_name || 'Нет названия'}
                />

                {strategyParams?.map(({
                    portal_name,
                    name,
                    type,
                    id,
                    attr_id,
                    value = ''
                }) => {
                    const paramKey = id || attr_id!;
                    const currentValue = (typeof strategyParamValue[paramKey]?.value === 'undefined') ? value?.value : strategyParamValue[paramKey]?.value;

                    if ((type === 'boolean') || (value?.type === 'boolean')) {
                        return (
                            <Checkbox
                                key={paramKey}
                                onChange={(e: boolean) => {
                                    setStrategyParamValue(prev => ({
                                        ...prev,
                                        [paramKey]: {
                                            type: 'boolean',
                                            value: e
                                        }
                                    }));
                                }}
                                checked={currentValue}
                            >
                                {portal_name || name}
                            </Checkbox>
                        );
                    }

                    return (
                        <InputDinamycPlaceholder
                            key={paramKey}
                            onChange={(e: string) => {
                                let paramValue = value?.value ?? value;
                                let paramType = type ?? value?.type;

                                if (paramType === 'integer') paramValue = Number(e);
                                if (paramType === 'string') paramValue = String(e);

                                setStrategyParamValue(prev => ({
                                    ...prev,
                                    [paramKey]: {
                                        type: paramType,
                                        value: paramValue
                                    }
                                }));
                            }}
                            placeholder={portal_name || name || ''}
                            autoComplete={false}
                            changeValue={value?.value ? String(value.value) : value}
                            size="s"
                        />
                    );
                })}

                <ButtonBasic
                    grey
                    width="100%"
                    text={strategyParams?.length ? 'Сохранить' : 'ОК'}
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        onClose();
                        onChangeStrategy(strategyInfo);
                        setStrategyParams([])
                        setStrategyParamValue({})
                    }}
                />
            </div>
        </div>
    );
};

export { ModalParamsRules };